var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M10.6074696,26.2759862 L26.036041,41.2224147 C29.3600273,44.4425265 34.6399727,44.4425265 37.963959,41.2224147 L53.3925304,26.2759862 C55.0591807,24.6614187 56,22.440105 56,20.1196414 L56,19.875 C56,18.9685767 55.2651987,18.2337741 54.3587754,18.2337741 C53.932515,18.2337741 53.5229765,18.3996165 53.2168191,18.6962065 L37.963959,33.4724147 C34.6399727,36.6925265 29.3600273,36.6925265 26.036041,33.4724147 L10.7831809,18.6962065 C10.1321512,18.0655214 9.0931161,18.0820141 8.46243108,18.7330438 C8.16584117,19.0392011 8,19.4487396 8,19.875 L8,20.1196414 C8,22.440105 8.9408193,24.6614187 10.6074696,26.2759862 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownIcon);
export default __webpack_public_path__ + "static/media/down-icon.d79eb1ed68a29e3d5c39b8aad421cf7c.svg";
export { ForwardRef as ReactComponent };